if (!customElements.get('hoculus-cta-sticky')) {

    class HoculusPdpCtaSticky extends HTMLElement {
        constructor() {
            super();
            this.targetElements = document.querySelectorAll(this.dataset.target);
            console.log(this.targetElements);
            this.ctaElement = this.querySelector('.button-cta');
            this.ctaElementValue = this.ctaElement.textContent;
            this.behavior = this.dataset.behavior;
            this.preOrderText = this.ctaElement.dataset.preOrderText;
        }

        connectedCallback() {
            if(this.targetElements.length <= 0) return;

            this.handleVisibilityCta();
            this.handleScrollBehavior();
            this.handleAtcTextContent();
        }

        handleAtcTextContent() {
            const span = this.ctaElement.querySelector('span');
            [...document.querySelectorAll('input[data-variant-pre-order]')].some(i => i.checked) && (span.textContent = this.preOrderText);
            
            document.addEventListener('change', (e) => {
                if (!e.target.matches('input[type="radio"]')) return;
                const hasPreOrder = [...document.querySelectorAll('input[data-variant-pre-order]')].some(i => i.checked);
                span.textContent = hasPreOrder ? this.preOrderText : this.ctaElementValue;
            });
        }

        initObserver() {
            const classTarget = 'is_visible';

            const observer = new IntersectionObserver((entries) => {
                const anyIntersecting = entries.some(entry => entry.isIntersecting);


                const isMobile = window.innerWidth <= 768;
                const scrolled = window.scrollY || window.pageYOffset;

                if (anyIntersecting) {
                    this.classList.remove(classTarget);
                } else {
                    if (isMobile && scrolled < 550) {
                        this.classList.remove(classTarget);
                    } else if (isMobile) {
                        this.classList.add(classTarget);
                    } else {
                        this.classList.add(classTarget);
                    }
                }
            }, {
                threshold: 0,
            });

            // Observe ALL target elements (description + footer)
            this.targetElements.forEach(el => observer.observe(el));
        }

        handleScrollBehavior(){
            this.ctaElement.addEventListener('click', () => {
                switch(this.behavior) {
                    case 'top':
                        window.scrollTo({top: 0, behavior: 'smooth'});
                        break;
                    case 'first_step':
                        this.handleScrollIntoView(document.querySelector('.product__variants-list'));
                        break;
                    case 'second_step':
                        this.handleScrollIntoView(document.querySelector('.product__quantity-discounts'));
                        break;
                    case 'third_step':
                        const addOnWrapper = document.querySelector('.add-on-wrapper');
                        addOnWrapper ? this.handleScrollIntoView(addOnWrapper) : window.scrollTo({top: 0, behavior: 'smooth'});
                        break;
                    default:
                        window.scrollTo({top: 0, behavior: 'smooth'});
                }
            });
        }

        handleScrollIntoView(element){
            element.scrollIntoView({behavior: 'smooth', block: 'center', inline: "nearest"});
        }


        handleVisibilityCta() {
            this.initObserver();
        }
    }

    customElements.define('hoculus-cta-sticky', HoculusPdpCtaSticky)
}